export const inscriptionConstants = {
  GET_INSCRIPTIONS: "GET_INSCRIPTIONS",
  GET_INSCRIPTION: "GET_INSCRIPTION",
  SET_LOADING: "SET_LOADING",
};
